import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]

import { Configuration } from "@/guiide/ts/configuration/configuration";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Modal from "./Modal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Help',
  props: {
  title: { type: String, required: false, default: "" },
  text: { type: Object as () => Array<string>, required: false },
  isWide: { type: Boolean, required: false, default: false },
  color: { type: String, default: "" },
  enabled: { type: Boolean, default: true },
  display: { type: Boolean, default: true }
},
  setup(__props) {

const props = __props;

const store = useStore();
const showHelpAnchor = ref<HTMLElement>(null);
const helpModal = ref(null);

const customIcon = computed<string>(() => {
  return store.state.configuration?.customHelpIcon ?? "";
});

const hasCustomIcon = computed<boolean>(() => {
  return customIcon.value.length > 0;
});

const questionFillColor = computed<string>(() => {
  const selectedColor = props.color != null && props.color != ""
          ? props.color
          : Configuration.getCssVariableValue("--quaternary-color");
  return `color: ${selectedColor};`;
});

function getTitleWithoutSpaces() {
  return props.title.replace(/ /g, "");
}

function onHelpClick() {
  
  if (props.enabled) {
    helpModal.value.showModal();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.display)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          ref_key: "showHelpAnchor",
          ref: showHelpAnchor,
          onClick: _withModifiers(onHelpClick, ["prevent"]),
          onKeydown: _withKeys(onHelpClick, ["enter"]),
          tabindex: "0",
          role: "button",
          "aria-label": `Open help for ${__props.title}`
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "visually-hidden-focusable" }, "Click this link to open the help content", -1)),
          (hasCustomIcon.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: customIcon.value,
                style: {"width":"1.2rem"}
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("i", {
                key: 1,
                class: "bi bi-question-circle-fill",
                style: _normalizeStyle(questionFillColor.value)
              }, null, 4))
        ], 40, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      ref_key: "helpModal",
      ref: helpModal,
      title: __props.title,
      idKey: getTitleWithoutSpaces(),
      icon: "bi-question-circle-fill",
      isWide: __props.isWide,
      returnFocusTo: showHelpAnchor.value,
      customIconOverride: customIcon.value
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.text, (para, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: i,
            innerHTML: para
          }, null, 8, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "idKey", "isWide", "returnFocusTo", "customIconOverride"])
  ], 64))
}
}

})